import { useState } from "react";
import { ID, OrderDetailType } from "../types/server";
import { get_order_by_id_api } from "../ducks/basket/api";
import { showMessage } from "react-native-flash-message";

export default useOrder;

interface Arguments {
  order_id: ID;
}

function useOrder({ order_id }: Arguments) {
  let [data, setData] = useState<OrderDetailType>(undefined);
  let [error, setError] = useState(undefined);
  let [revalidating, setRevalidating] = useState(true);
  async function revalidate() {
    setRevalidating(true);
    try {
      let id = `or_${order_id}`;
      let response = await get_order_by_id_api(id);
      setData(response);
    } catch (e) {
      setError(e);

      showMessage({
        type: "danger",
        message: e,
      });
    } finally {
      setRevalidating(false);
    }
  }

  return {
    data,
    error,
    revalidate,
    revalidating,
  };
}
